import { render, staticRenderFns } from "./BusinessAnnualReturnForms.vue?vue&type=template&id=1c681118&scoped=true&"
import script from "./BusinessAnnualReturnForms.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnForms.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAnnualReturnForms.vue?vue&type=style&index=0&id=1c681118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c681118",
  null
  
)

export default component.exports